
<div>
  @if (info.isPage) {
    <p class="text-alert">
      <b>{{'PageInfoText' | translate}}</b>
      <span class="config-links">
        <a href="javascript:void(0)" data-automation-id="lm-componentinfo-page-info-link" (click)="showPageComponentInfo($event)">{{'ClickHere' | translate}}</a>
      </span>
      <br/><br/>
    </p>
  }

  @if (info.busClassName) {
    <p data-automation-id="lm-componentinfo-business-class"><span class="attribute-title label-colon">{{'BusinessClass' | translate}}</span><span class="attribute-answer"> {{info.busClassName}}</span></p>
  }
  @if (info.module) {
    <p data-automation-id="lm-componentinfo-module"><span class="attribute-title label-colon">{{'Module' | translate}}</span> <span class="attribute-answer">{{info.module}}</span></p>
  }

  @if (info.cardviewSpec) {
    <div class="titles">
      <b class="menu-title menu-layer">{{'CardViewInfo' | translate}}</b>
      @if (info.cardviewSpec.id) {
        <p data-automation-id="lm-componentinfo-card-view-name">
          <span class="attribute-title label-colon">{{'CardViewName' | translate}}</span> <span class="attribute-answer"> {{info.cardviewSpec.id}}</span>
        </p>
      }
      <ng-container *ngTemplateOutlet="configInfoMarkup; context:{compInfo: info.cardviewSpec, busName:info.busClassName ,name:info.cardviewSpec.id}"></ng-container>
    </div>
  }

  @if (info.panelSpec) {
    <div class="titles">
      <b class="menu-title menu-layer">{{'FormPanelInfo' | translate}}</b>
      @if (info.panelSpec.formName) {
        <p data-automation-id="lm-componentinfo-panel-form-name">
          <span class="attribute-title label-colon">{{'PanelFormName' |translate}}</span> <span class="attribute-answer">{{info.panelSpec.formName}}</span>
        </p>
      }
      <ng-container *ngTemplateOutlet="configInfoMarkup; context:{compInfo: info.panelSpec, busName:info.busClassName ,name:info.panelSpec.formName}"></ng-container>
    </div>
  }

  @if (info.contextFormSpec) {
    <div class="titles">
      <b class="menu-title menu-layer">{{'ContextFormInfo' | translate }}</b>
      @if (info.contextFormSpec.name) {
        <p data-automation-id="lm-componentinfo-context-form-name">
          <span class="attribute-title label-colon">{{'ContextFormName' | translate}}</span><span class="attribute-answer"> {{info.contextFormSpec.name}}</span>
        </p>
      }
      @if (info.contextFormSpec.configuration) {
        <p data-automation-id="lm-componentinfo-context-form-is-configured">
          <span class="attribute-title">{{'IsConfigured' | translate}}</span>
        </p>
      }
      <ng-container *ngTemplateOutlet="resourceInfoMarkup; context:{resourceInfo: info.contextFormSpec.resourceInfo}"></ng-container>
      <ng-container *ngTemplateOutlet="lplInfoMarkup; context:{lpl: info.contextFormSpec.lpl}"></ng-container>
      <ng-container *ngTemplateOutlet="configInfoMarkup; context:{compInfo: info.contextFormSpec, busName:info.busClassName ,name:info.contextFormSpec.name}"></ng-container>
    </div>
  }

  @if (info.panelSpec || info.contextFormSpec || info.cardviewSpec) {
    <div class="titles">
      <b class="menu-title menu-layer">{{'ParentCompInformation' | translate: upperCase(info.componentType)}}</b>
    </div>
  }

  @if (info.panelSpec === undefined && !info.contextFormSpec && !info.cardviewSpec) {
    <div class="titles">
      <b class="menu-title menu-layer">{{'CompInformation'| translate: upperCase(info.componentType)}}</b>
    </div>
  }
  <!-- <p><b>{{'LPLViewName' | translate}}</b> {{info.name}}</p> -->

      <div class="row">
        <p>
            <span class="attribute-title label-colon" style="height: 24px;">{{'CompName' | translate: upperCase(info.componentType)}}</span>
            @if (!info.inlineSearchForm) {
                <span class="attribute-answer" data-automation-id="lm-componentinfo-comp-name">{{info.name}}</span>
                <span class="config-links">
                  @if (info.listUrl) {
                    <a href="javascript:void(0)" (click)="clickOpenLink(); " class="open-links inline-open" data-automation-id="lm-componentinfo-list-link"><span class="attribute-answer">{{'Open' | translate}}</span></a>
                  }
                  @if (info.formRequestUrl) {
                    <a href="javascript:void(0)" (click)="clickOpenLink(); " class="open-links inline-open" data-automation-id="lm-componentinfo-form-link"><span class="attribute-answer">{{'Open' | translate}}</span></a>
                  }
                </span>
            }  @else {
                    <span class="attribute-answer"><div>{{'InlineFormDefMessage' | translate}}</div></span>
            }
        </p>
      </div>


<div class="row">
  @if (info.formName) {
    <p class="paragraph-break" data-automation-id="lm-componentinfo-form-name"><span class="attribute-title label-colon">{{'FormName' | translate}}</span> <span class="attribute-answer">{{info.formName}}</span></p>
  }
</div>
<div class="row">
  @if (info.userWebRequestId) {
    <p data-automation-id="lm-componentinfo-web-request-id"><span class="attribute-title label-colon">{{'UICompId' | translate}}</span> <span class="attribute-answer">{{info.userWebRequestId}}</span></p>
  }
</div>
<div class="row">
  @if (info.pageTitle) {
    <p data-automation-id="lm-componentinfo-page-title"><span class="attribute-title label-colon">{{'PageTitle' | translate}}</span> <span class="attribute-answer">{{info.pageTitle}}</span></p>
  }
</div>
<div class="row">
  @if (info.fieldSize) {
    <p data-automation-id="lm-componentinfo-field-size"><span class="attribute-title label-colon">{{'FieldSize' | translate}}</span> <span class="attribute-answer">{{info.fieldSize}}</span></p>
  }
</div>
<div class="row">
  @if (info.fieldSize && info.type) {
    <p data-automation-id="lm-componentinfo-field-type"><span class="attribute-title label-colon">{{'FieldType' | translate}}</span> <span class="attribute-answer">{{info.type}}</span></p>
  }
</div>
<div class="row">
  @if (info.parentLink && (info.parentLink !== info.name)) {
    <p data-automation-id="lm-componentinfo-parent-link"><span class="attribute-title label-colon">{{'ParentLink' | translate}}</span> <span class="attribute-answer">{{info.parentLink}}</span></p>
  }
</div>
@if (info.stateValues) {
  <div style="display: flex">
    <p><span class="attribute-title label-colon">{{'StateValues' | translate}}</span></p>
    <section class="scrollable-flex-header expandable-area custom-inline-expand" data-automation-id="lm-componentinfo-state-values" [class.is-expanded]="false" style="flex-grow: 1;">
      <div class="expandable-pane">
        <pre> {{info.stateValues}} </pre>
      </div>
    </section>
  </div>
}

<div class="row">
  @if (info.chartName) {
    <p data-automation-id="lm-componentinfo-chart-name"><span class="attribute-title label-colon">{{'ChartName' | translate}}</span> <span class="attribute-answer">{{info.chartName}}</span></p>
  }
</div>
<div class="row">
  @if (info.resourceType) {
    <p data-automation-id="lm-componentinfo-resource-type"><span class="attribute-title label-colon">{{'ResourceType' | translate}}</span> <span class="attribute-answer">{{info.resourceType}}</span></p>
  }
</div>
<!-- <p *ngIf="info.resourceId"><span class="attribute-title label-colon">{{'ResourceId' | translate}}</span> <span class="attribute-answer">{{info.resourceId}}</span></p>  -->

<!-- <div *ngIf="info.listUrl" class="titles">
<b>{{'ListUrl' | translate}}</b>
<a href="{{info.listUrl}}" target="_blank">{{'Open' | translate}}</a>
<a href="#" (click)="showHideListUrl(); ">{{'ShowHideUrl' | translate}}</a>
<div class="url-content" *ngIf="showListUrl">{{info.listUrl}}</div>
</div> -->

<ng-container *ngTemplateOutlet="resourceInfoMarkup; context:{resourceInfo: info.resourceInfo}"></ng-container>

@if (info.link) {
  <div class="titles">
    <b class="menu-title label-colon">{{'Menu' | translate}}</b>
    @if (info.id) {
      <p data-automation-id="lm-componentinfo-menu-id"><span class="attribute-title label-colon">{{'IdLabel' | translate}}</span> <span class="attribute-answer">{{info.id}}</span></p>
    }
    @if (info.label) {
      <p data-automation-id="lm-componentinfo-menu-label"><span class="attribute-title label-colon">{{'MenuLabel' | translate}}</span> <span class="attribute-answer">{{info.label}}</span></p>
    }
    @if (info.link) {
      <p data-automation-id="lm-componentinfo-menu-link"><span class="attribute-title label-colon">{{'MenuLink' | translate}}</span> <span class="attribute-answer">{{info.link}}</span></p>
    }
    @if (info.menuIndex) {
      <p data-automation-id="lm-componentinfo-menu-index"><span class="attribute-title label-colon">{{'MenuIndex' | translate}}</span> <span class="attribute-answer">{{info.menuIndex}}</span></p>
    }
    @if (info.parent) {
      <p data-automation-id="lm-componentinfo-parent"><span class="attribute-title label-colon">{{'Parent' | translate}}</span> <span class="attribute-answer">{{info.parent}}</span></p>
    }
    @if (info.parentLabel) {
      <p data-automation-id="lm-componentinfo-parent-label"><span class="attribute-title label-colon">{{'ParentLabel' | translate}}</span><span class="attribute-answer"> {{info.parentLabel}}</span></p>
    }
    @if (info.target) {
      <p data-automation-id="lm-componentinfo-target"><span class="attribute-title label-colon">{{'MenuTarget' | translate}}</span><span class="attribute-answer"> {{info.target}}</span></p>
    }
  </div>
}

    @if (!info.inlineSearchForm) {
        <ng-container *ngTemplateOutlet="configInfoMarkup; context:{compInfo: info, busName:info.busClassName ,name:info.name}"></ng-container>
    }
    @if (info.hasConfigAccess && (showListOpenLink || showFormOpenLink || showFieldOpenLink)) {
        <div>
          <button class="collapse-button" type="button" (click)="toggleApiDoc()" data-automation-id="lm-componentinfo-api-documentation-toggle-button">
            <span><b class="collapse-titles">{{'APIDocumentation' | translate}}</b></span>
            @if (!showApiDoc) {
              <svg class="icon icon-closed icon-pos" focusable="false" aria-hidden="true" role="presentation">
                <use href="#icon-caret-down"></use>
              </svg>
            }
            @if (showApiDoc) {
              <svg class="icon icon-opened icon-pos" focusable="false" aria-hidden="true" role="presentation">
                <use href="#icon-caret-up"></use>
              </svg>
            }
          </button>
          <div>
            <div #apiDocContent class="animate-developer" data-automation-id="lm-componentinfo-api-documentation-info">
              <div class="content icon-pos">
                <ng-container *ngTemplateOutlet="swaggerLinks;"></ng-container>
              </div>
            </div>
          </div>
        </div>
    }

@if (info.developer) {
  <div>
    <button class="collapse-button" type="button"  (click)="toggleDeveloper()" data-automation-id="lm-componentinfo-developer-information-toggle-button">
      <span><b  class="collapse-titles">{{'DeveloperInformation' | translate}}</b></span>
      @if (!showDeveloper) {
        <svg class="icon icon-closed icon-pos" focusable="false" aria-hidden="true" role="presentation">
          <use href="#icon-caret-down"></use>
        </svg>
      }
      @if (showDeveloper) {
        <svg class="icon icon-opened icon-pos" focusable="false" aria-hidden="true" role="presentation">
          <use href="#icon-caret-up"></use>
        </svg>
      }
    </button>
    <div>
      <div #developerContent class="animate-developer" data-automation-id="lm-componentinfo-developer-info">
        <div class="content icon-pos">
          <ng-container *ngTemplateOutlet="developerInfoMarkup; context:{compInfo: info}"></ng-container>
        </div>
      </div>
    </div>
  </div>
}

<div>
  <button class="collapse-button" type="button"  (click)="toggleDebugger()" data-automation-id="lm-componentinfo-triage-toggle-button">
    <div>
      <span><b class="collapse-titles">{{'DebugTool' | translate}}</b></span>
      @if (!showDebug) {
        <svg class="icon icon-closed icon-pos" focusable="false" aria-hidden="true" role="presentation">
          <use href="#icon-caret-down"></use>
        </svg>
      }
      @if (showDebug) {
        <svg class="icon icon-opened icon-pos" focusable="false" aria-hidden="true" role="presentation">
          <use href="#icon-caret-up"></use>
        </svg>
      }
    </div>
  </button>

  <div>
    <div #debugContent class="animate-developer" data-automation-id="lm-componentinfo-triage-info">
      <div class="content icon-pos debug-container">
        <ng-container *ngTemplateOutlet="showDebugMarkup; context:{compInfo: info}"></ng-container>
      </div>
    </div>
  </div>
</div>

<!--  REUSE TEMPLATES BELOW  -->

<ng-template let-developernfo="developerInfo" let-compInfo="compInfo" #showDebugMarkup>
  @if (!compInfo?.isDBSessionDebugActive) {
    <div class="field debug-input-field">
      <p class="debug-paragraph">
        <span class="attribute-title label-colon">{{'DBSessionName' | translate}}</span> <span class="attribute-answer">
        <input type="text" id="dbSessionId" class="debug-title debug-name" data-automation-id="lm-componentinfo-db-session" name="dbSessionId" #debugSessionId  (change)="changeDebugID(debugSessionId.value);" value="{{debugName}}"/>
      </span>
    </p>
  </div>
  <div class="field debug-input-field">
    <p class="debug-paragraph">
      <span class="attribute-title label-colon">{{'DBDebugLevel' | translate}}</span> <span class="attribute-answer">
      <select id="debugLevelId" name="debugLevelId" data-automation-id="lm-componentinfo-debug-level-dropdown" class="dropdown debug-level-element" #debugLevel (change)="setDebugLevel(debugLevel.value);">
        <option value="minimal">{{'DBDebugLevelOptionMinimal' | translate}}</option>
        <option value="basic">{{'DBDebugLevelOptionBasic' | translate}}</option>
        <option value="standard" selected >{{'DBDebugLevelOptionStandard' | translate }}</option>
        <option value="verbose">{{'DBDebugLevelOptionVerbose' | translate}} </option>
      </select>
    </span>
  </p>
</div>
<div class="field debug-input-field">
  <p class="debug-paragraph">
    <span class="attribute-title label-colon">{{'DBDebugLimit' | translate}}</span> <span class="attribute-answer">
    <select id="debugLimitId" name="debugLimitId" data-automation-id="lm-componentinfo-debug-limit-dropdown" class="dropdown debug-level-element" #debugLimit (change)="setDebugLimit(debugLimit.value);">
      <option value="screen" selected>{{'DBDebugScreenOption' | translate}}</option>
      <option value="dataOnly">{{'DBDebugDataOnlyOption' | translate}}</option>
    </select>
  </span>
</p>
</div>
<div class="field debug-input-field">
  <a id="primary-aslink" class="btn-primary debug-button debug-title" href="javascript:void(0)" (click)="openDebugger();" data-automation-id="lm-componentinfo-open-debugger-button">
    <span>{{'OpenDebugger' | translate}}</span>
  </a>
  <input type="checkbox" class="checkbox" name="checkbox1"  id="debugtrace" #debugTrace  (click)="toggleTrace(debugTrace.checked);" data-automation-id="lm-componentinfo-debug-trace-checkbox"/>
  <label for="debugtrace" class="checkbox-label debug-title debug-checkbox-label">{{'OpenTrace' | translate}}</label>
</div>
}

<!-- DB Session Debug is Active -->
@if (compInfo?.isDBSessionDebugActive && dbSessionDebugResourceId) {
  <div class="titles" data-automation-id="lm-componentinfo-db-session-info">
    <b class="menu-title menu-layer">{{ 'DBSessionDebugInformation' | translate }}</b>
  </div>
  <div class="row">
    <p data-automation-id="lm-componentinfo-db-session-info-name">
      <span class="attribute-title label-colon">{{ 'DBSessionDebugName' | translate }}</span>
      <span class="attribute-answer">{{ compInfo?.dbSessionId }}</span>
    </p>
  </div>
  <div class="row">
    <p data-automation-id="lm-componentinfo-db-session-info-result">
      <span class="attribute-title label-colon">{{ 'DBSessionDebugResult' | translate }}</span>
      <span class="attribute-answer">
        <ids-hyperlink data-automation-id="lm-componentinfo-db-session-result-view" (click)="onViewDBSessionDebugResult()">{{ 'View' | translate }}</ids-hyperlink> |
        <ids-hyperlink data-automation-id="lm-componentinfo-db-session-result-download" (click)="onDownloadDBSessionDebugResult()">{{ 'Download' | translate }}</ids-hyperlink>
      </span>
    </p>
  </div>
}
<br/><br/><hr class="debug-split" /><br/><br/>
<div class="field">
  <a id="primary-aslink" class="btn-primary debug-button debug-title" href="javascript:void(0)" (click)="openSecurityDebugger();" data-automation-id="lm-componentinfo-sec-debugger-link">
    <span>{{'OpenSecDebugger' | translate}}</span>
  </a>
  @if (listUrl) {
    <a id="primary-costlink" class="btn-primary debug-button debug-title" href="#" (click)="openListCostReport();" data-automation-id="lm-componentinfo-cost-report">
      <span>{{'OpenListCostReport' | translate}}</span>
    </a>
  }
</div>
</ng-template>

<ng-template let-developerInfo="developerInfo" let-compInfo="compInfo" #developerInfoMarkup>
  <p  data-automation-id="lm-componentinfo-component-type"><span class="attribute-title label-colon">{{'ComponentType' | translate}}</span> <span class="attribute-answer">{{info.componentType | capitalize}}</span></p>
  @if (info.fieldSize === undefined) {
    <p data-automation-id="lm-componentinfo-view-type"><span class="attribute-title label-colon">{{'ViewType' | translate}}</span> <span class="attribute-answer">{{info.type}}</span></p>
  }
  @if (info.panelSpec && info.panelSpec.panelId) {
    <p data-automation-id="lm-componentinfo-panel-id"><span class="attribute-title label-colon">{{'PanelId' | translate}}</span> <span class="attribute-answer">{{info.panelSpec.panelId}}</span></p>
  }
  @if (info.displayType) {
    <p data-automation-id="lm-componentinfo-display-type"><span class="attribute-title label-colon">{{'DisplayType' | translate}}</span> <span class="attribute-answer">{{info.displayType}}</span></p>
  }
  @if (info.fromListResourceId) {
    <p data-automation-id="lm-componentinfo-from-list-resource-id"><span class="attribute-title label-colon">{{'FromListResourceId' | translate}}</span> <span class="attribute-answer">{{info.fromListResourceId}}</span></p>
  }
  @if (info.status) {
    <p data-automation-id="lm-componentinfo-status">{{info.componentType | capitalize}} <span class="attribute-title label-colon">{{'Status' | translate}}</span> <span class="attribute-answer">{{info.status}}</span></p>
  }
  @if (info.developer && compInfo.configInfo && compInfo.configInfo.configStamp && compInfo.configInfo.configStamp > 0) {
    <p data-automation-id="lm-componentinfo-config-stamp"><span class="attribute-title label-colon">{{'ConfigStamp' | translate}}</span> {{compInfo.configInfo.configStamp}}</p>
  }
  @if (info.developer && compInfo.configInfo && compInfo.configInfo.classConfigStamp && compInfo.configInfo.classConfigStamp > 0) {
    <p data-automation-id="lm-componentinfo-class-config-stamp"><span class="attribute-title label-colon">{{'ClassConfigStamp' | translate}}</span> {{compInfo.configInfo.classConfigStamp}}</p>
  }
  @if (info.panelNavigation) {
    <p data-automation-id="lm-componentinfo-panel-navigation"><span class="attribute-title label-colon">{{'PanelNavigation' | translate}}</span> <span class="attribute-answer">{{info.panelNavigation}}</span></p>
  }
  @if (info.routeReuse) {
    <p data-automation-id="lm-componentinfo-route-reuse"><span class="attribute-title label-colon">{{'RouteReuse' | translate}}</span> <span class="attribute-answer">{{info.routeReuse}}</span></p>
  }
  @if (info.isWizard) {
    <p data-automation-id="lm-componentinfo-is-wizard"><span class="attribute-title label-colon">{{'IsWizard' | translate}}</span> {{info.isWizard}}</p>
  }
  @if (info.specField) {
    <div style="display: flex">
      <p><span class="attribute-title label-colon">{{'SpecField' | translate}}</span></p>
      <section class="scrollable-flex-header expandable-area custom-inline-expand" data-automation-id="lm-componentinfo-spec-field" [class.is-expanded]="false" style="flex-grow: 1;">
        <div class="expandable-pane">
          <pre> {{info.specField}} </pre>
        </div>
      </section>
    </div>
  }
  @if (info.fieldLayout) {
    <div style="display: flex">
      <p><span class="attribute-title label-colon">{{'Layout' | translate}}</span></p>
      <section class="scrollable-flex-header expandable-area custom-inline-expand" data-automation-id="lm-componentinfo-field-layout" [class.is-expanded]="false" style="flex-grow: 1;">
        <div class="expandable-pane">
          <pre> {{info.fieldLayout}} </pre>
        </div>
      </section>
    </div>
  }
  @if (info.formRequestUrl) {
    <div class="titles link-group-xpand">
      <span class="attribute-title label-colon">{{'FormUrl' | translate}}</span>
      <span  class="config-links">
        <a href="{{info.formRequestUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-form-request-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
        <a href="javascript:void(0)" (click)="showHideFormRequestUrl(); " data-automation-id="lm-componentinfo-show-hide-form-request-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      </span>
      @if (showFormRequestUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-form-request-url">{{info.formRequestUrl}}</div>
      }
    </div>
  }
  @if (info.firstPageUrl) {
    <div class="titles config-links link-group-xpand">
      <span class="attribute-title label-colon">{{'FirstPage' | translate}}</span>
      <a href="{{info.firstPageUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-first-page-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHideFirstPageUrl();" data-automation-id="lm-componentinfo-show-hide-first-page-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showFirstPageUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-first-page-url">{{info.firstPageUrl}}</div>
      }
    </div>
  }
  @if (info.nextPageUrl) {
    <div class="titles config-links link-group-xpand">
      <span class="attribute-title label-colon">{{'NextPage' | translate}}</span>
      <a href="{{info.nextPageUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-next-page-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHideNextPageUrl();" data-automation-id="lm-componentinfo-show-hide-next-page-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showNextPageUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-next-page-url">{{info.nextPageUrl}}</div>
      }
    </div>
  }
  @if (info.previousPageUrl) {
    <div class="titles config-links link-group-xpand">
      <span class="attribute-title label-colon">{{'PreviousPage' | translate}}</span>
      <a href="{{info.previousPageUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-previous-page-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHidePreviousPageUrl();" data-automation-id="lm-componentinfo-show-hide-previous-page-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showPreviousPageUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-previous-page-url">{{info.previousPageUrl}}</div>
      }
    </div>
  }
  @if (info.lastPageUrl) {
    <div class="titles config-links link-group-xpand">
      <span class="attribute-title label-colon">{{'LastPage' | translate}}</span>
      <a href="{{info.lastPageUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-last-page-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHideLastPageUrl();" data-automation-id="lm-componentinfo-show-hide-last-page-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showLastPageUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-last-page-url">{{info.lastPageUrl}}</div>
      }
    </div>
  }
  @if (info.reloadPageUrl) {
    <div class="titles config-links link-group-xpand">
      <span class="attribute-title label-colon">{{'ReloadPage' | translate}}</span>
      <a href="{{info.reloadPageUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-reload-page-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHideReloadPageUrl();" data-automation-id="lm-componentinfo-show-hide-reload-page-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showReloadPageUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-reload-page-url">{{info.reloadPageUrl}}</div>
      }
    </div>
  }

  @if (info.nextRecordUrl) {
    <div class="titles config-links link-group-xpand">
      <span class="attribute-title label-colon">{{'NextRecord' | translate}}</span>
      <a href="{{info.nextRecordUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-next-record-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHideNextRecordUrl();" data-automation-id="lm-componentinfo-show-hide-next-record-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showNextRecordUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-next-record-url">{{info.nextRecordUrl}}</div>
      }
    </div>
  }
  @if (info.previousRecordUrl) {
    <div class="titles config-links link-group-xpand">
      <span class="attribute-title label-colon">{{'PreviousRecord' | translate}}</span>
      <a href="{{info.previousRecordUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-previous-record-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHidePreviousRecordUrl();" data-automation-id="lm-componentinfo-show-hide-previous-record-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showPreviousRecordUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-previous-record-url">{{info.previousRecordUrl}}</div>
      }
    </div>
  }
  @if (info.reloadRecordUrl) {
    <div class="titles config-links link-group-xpand">
      <span class="attribute-title label-colon">{{'ReloadRecord' | translate}}</span>
      <a href="{{info.reloadRecordUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-reload-record-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHideReloadRecordUrl();" data-automation-id="lm-componentinfo-show-hide-reload-record-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showReloadRecordUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-reload-record-url">{{info.reloadRecordUrl}}</div>
      }
    </div>
  }
  <ng-container *ngTemplateOutlet="lplInfoMarkup; context:{lpl: info.lpl}"></ng-container>
  @if (info.loadedUrl) {
    <div class="titles">
      <span class="attribute-title label-colon">{{'UrlLoadedToIframe' | translate}}</span>
      <a href="{{info.loadedUrl}}" target="_blank" class="page-open-links" data-automation-id="lm-componentinfo-loaded-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHideLoadedUrl(); " data-automation-id="lm-componentinfo-show-hide-loaded-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showLoadedUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-loaded-url">{{info.loadedUrl}}</div>
      }
    </div>
  }
  @if (info.inputUrl) {
    <div class="titles">
      <span class="attribute-title label-colon">{{'UrlPassedToComponent' | translate}}</span>
      <a href="{{info.inputUrl}}" target="_blank" class="pageOpenpage-open-linksLinks" data-automation-id="lm-componentinfo-input-link"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="javascript:void(0)" (click)="showHideInputUrl(); " data-automation-id="lm-componentinfo-show-hide-input-url"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      @if (showInputUrl) {
        <div class="url-content" data-automation-id="lm-componentinfo-input-url">{{info.inputUrl}}</div>
      }
    </div>
  }
  @if (info.pageSpec) {
    <div style="display: flex">
      <p><span class="attribute-title label-colon">{{'PageSpec' | translate}}</span></p>
      <section class="scrollable-flex-header expandable-area custom-inline-expand" data-automation-id="lm-componentinfo-page-spec" [class.is-expanded]="false" style="flex-grow: 1;">
        <div class="expandable-pane">
          <pre> {{info.pageSpec}} </pre>
        </div>
      </section>
    </div>
  }
  @if (info.hasPanels) {
    <p data-automation-id="lm-componentinfo-has-panels"><span class="attribute-title label-colon">{{'HasPanels' | translate}}</span> <span class="attribute-answer">{{info.hasPanels}}</span></p>
  }
  @if (info.lmTabsOptions) {
    <div style="display: flex">
      <p><span class="attribute-title label-colon">{{'TabOptions' | translate}}</span></p>
      <section class="scrollable-flex-header expandable-area custom-inline-expand" data-automation-id="lm-componentinfo-lm-tabs-options" [class.is-expanded]="false" style="flex-grow: 1;">
        <div class="expandable-pane">
          <pre> {{info.lmTabsOptions}} </pre>
        </div>
      </section>
    </div>
  }
  @if (info.overrideListTitle) {
    <p data-automation-id="lm-componentinfo-override-list-title"><span class="attribute-title label-colon">{{'OverrideListTitle' | translate}}</span> <span class="attribute-answer">{{info.overrideListTitle}}</span></p>
  }
  @if (info.hideTitleBar) {
    <p data-automation-id="lm-componentinfo-hide-title-bar"><span class="attribute-title label-colon">{{'HideTitleBar' | translate}}</span>  <span class="attribute-answer">{{info.hideTitleBar}}</span> </p>
  }
  @if (info.toolbarButtons) {
    <p data-automation-id="lm-componentinfo-toolbar-buttons"><span class="attribute-title label-colon">{{'ToolbarButtons' | translate}}</span>  <span class="attribute-answer">{{info.toolbarButtons}}</span> </p>
  }
  @if (info.bottomSpacing) {
    <p data-automation-id="lm-componentinfo-bottom-spacing"><span class="attribute-title label-colon">{{'BottomSpacing' | translate}}</span>  <span class="attribute-answer">{{info.bottomSpacing}}</span> </p>
  }
  @if (info.adjustFrameToWindow || info.adjustFrameToWindow === false) {
    <p data-automation-id="lm-componentinfo-adjust-frame-to-window"><span class="attribute-title label-colon">{{'AdjustFrameToWindow' | translate}}</span>  <span class="attribute-answer">{{info.adjustFrameToWindow}}</span> </p>
  }
  @if (info.isDashboardPanel || info.isDashboardPanel === false) {
    <p data-automation-id="lm-componentinfo-is-dashboard-panel"><span class="attribute-title label-colon">{{'IsDashboardPanel' | translate}}</span>  <span class="attribute-answer">{{info.isDashboardPanel}}</span> </p>
  }
  @if (info.fieldManualRep || info.fieldManualRep === false) {
    <p data-automation-id="lm-componentinfo-field-manual-rep"><span class="attribute-title label-colon">{{'fieldManualRep' | translate}}</span>  <span class="attribute-answer">{{info.fieldManualRep}}</span> </p>
  }
  @if (info.uniqueId) {
    <p data-automation-id="lm-componentinfo-unique-id"><span class="attribute-title label-colon">{{'UniqueId' | translate}}</span>  <span class="attribute-answer">{{info.uniqueId}}</span> </p>
  }
  @if (info.showLoading || info.showLoading === false) {
    <p data-automation-id="lm-componentinfo-show-loading"><span class="attribute-title label-colon">{{'ShowLoading' | translate}}</span>  <span class="attribute-answer">{{info.showLoading}}</span> </p>
  }
  @if (info.manualRepFields) {
    <p data-automation-id="lm-componentinfo-manual-rep-fields"><span class="attribute-title label-colon">{{'ManualRepFields' | translate}}</span>  <span class="attribute-answer">{{info.manualRepFields}}</span> </p>
  }
  @if (info.isHtmlFragment) {
    <p data-automation-id="lm-componentinfo-is-html-fragment"><span class="attribute-title label-colon">{{'HtmlFragment' | translate}}</span>  <span class="attribute-answer">{{info.isHtmlFragment}}</span> </p>
  }
  <!-- <p *ngIf="info.developer"><span class="attribute-title label-colon">{{'Developer' | translate}}</span>  <span class="attribute-answer">{{info.developer}}</span> </p> -->

</ng-template>

<ng-template let-resourceInfo="resourceInfo" #resourceInfoMarkup>
  @if (resourceInfo && resourceInfo.resourceObject) {
    <p data-automation-id="lm-componentinfo-resource-object"><span class="attribute-title label-colon">{{'ResourceObject' | translate}}</span> <span class="attribute-answer">{{resourceInfo.resourceObject}}</span></p>
  }
  @if (resourceInfo && resourceInfo.resourceKey) {
    <p data-automation-id="lm-componentinfo-resource-key"><span class="attribute-title label-colon">{{'ResourceKey' | translate}}</span> <span class="attribute-answer">{{resourceInfo.resourceKey}}</span></p>
  }
  @if (resourceInfo && resourceInfo.resourceValue) {
    <p data-automation-id="lm-componentinfo-resource-value"><span class="attribute-title label-colon">{{'ResourceValue' | translate}}</span><span class="attribute-answer">{{resourceInfo.resourceValue}}</span></p>
  }
</ng-template>

<ng-template let-lpl="lpl" #lplInfoMarkup>
  @if (lpl) {
    <div style="display: flex">
      <p><span class="attribute-title label-colon">LPL</span></p>
      <section class="scrollable-flex-header expandable-area custom-inline-expand" data-automation-id="lm-componentinfo-lpl" [class.is-expanded]="false" style="flex-grow: 1;">
        <div class="expandable-pane">
          <pre> {{lpl}} </pre>
        </div>
      </section>
    </div>
  }
</ng-template>

<ng-template let-lpl="lpl" #swaggerLinks>
    <div class="row">
        <p><span class="attribute-title label-colon">{{'OpenApi' | translate: upperCase(info.componentType)}}</span> <span class="attribute-answer" data-automation-id="lm-componentinfo-comp-name">

          @if (info.swaggerRawUrl) {
            <span class="config-links">
                <a [href]="info.swaggerRawUrl"  target="_blank" class="btn-primary debug-button debug-title" data-automation-id="lm-componentinfo-list-link">
                    <span>{{'LegacySwaggerRaw' | translate}}</span>
                </a>
            </span>
          }
          @if (info.swaggerUrl) {
            <span class="config-links">
              <a [href]="info.swaggerUrl"  target="_blank" class="btn-primary debug-button debug-title" data-automation-id="lm-componentinfo-form-link">
                <span>{{'LegacySwagger' | translate}}</span>
              </a>
            </span>
          }
        </span></p>
    </div>
</ng-template>

<ng-template let-compInfo="compInfo" let-busName="busName" let-name="name" #configInfoMarkup>
  @if (compInfo.configInfo) {
    <div class="titles">
      <div class="row">
        @if (compInfo.configInfo.userlist) {
          <p class="config-tag-line" data-automation-id="lm-componentinfo-configured-new">
            <span class="attribute-title"><span class="config-tag">{{'ConfiguredNew' | translate}}</span></span>
          </p>
        }
      </div>
      <div class="row">
        @if (compInfo.configInfo.folder) {
          <p class="config-tag-line" data-automation-id="lm-componentinfo-personalized">
            <span class="attribute-title"><span class="config-tag">{{'IsPersonalized' | translate}}</span></span>
          </p>
        }
      </div>
      <div class="row">
        @if (compInfo.configInfo.personalization) {
          <p class="config-tag-line" data-automation-id="lm-componentinfo-personalized">
            <span class="attribute-title"><span class="config-tag">{{'IsPersonalized' | translate}}</span></span>
          </p>
        }
      </div>
      <div class="row">
        @if (!compInfo.configInfo.personalization && !compInfo.configInfo.userlist && !compInfo.configInfo.folder && compInfo.configInfo.configuration) {
          <p class="config-tag-line">
            <span class="attribute-title" data-automation-id="lm-componentinfo-configured"><span class="config-tag">{{'IsConfigured' | translate}}</span></span>
            @if (compInfo.configInfo.configuration && info.hasConfigAccess) {
              <span>
                <a href="javascript:void(0)" class="config-links" data-automation-id="lm-componentinfo-view-configuration-link" (click)="viewConfiguration(compInfo, busName, name)" class="create-config"><span class="trigger-config attribute-answer">{{'ViewConfiguration' | translate}}</span></a>
              </span>
            }
          </p>
        }
      </div>
      <div class="row">
        @if (!compInfo.configInfo.personalization && !compInfo.configInfo.configuration && !compInfo.configInfo.configureUrl && !compInfo.configInfo.configureUrl
          && !compInfo.configInfo.personalizeTabs && !compInfo.configInfo.userlist && !compInfo.configInfo.folder && !compInfo.configInfo.configStamp) {
          <p class="config-tag-line">
            @if (info.hasConfigAccess) {
              <span class="attribute-title" data-automation-id="lm-componentinfo-no-config"><span class="delivered-tag">{{'NoConfigurationInfo' | translate}}</span></span>
            }
            @if (!info.hasConfigAccess) {
              <span class="attribute-title" data-automation-id="lm-componentinfo-no-config" style="width: 100%;"><span class="delivered-tag">{{'NoConfigurationInfo' | translate}}</span></span>
            }
            @if (info.hasConfigAccess  && !compInfo.configInfo.configuration) {
              <span class="config-links" >
                <a href="javascript:void(0)" data-automation-id="lm-componentinfo-create-configuration-link" (click)="createConfiguration(compInfo, busName, name);" class="create-config"><span class="trigger-config attribute-answer">{{'CreateConfiguration' | translate}}</span></a>
              </span>
            }
          </p>
        }
      </div>
      <div class="row">
        @if (info.hasConfigAccess) {
          <p  class="config-tag-line">
            <span class="attribute-title label-colon">{{'ViewDelivered' | translate}}</span>
            <span class="delivered-config">
              <a href="javascript:void(0)" data-automation-id="lm-componentinfo-view-delivered-link" (click)="runViewBaseLpl(compInfo, busName, name);"><span class="attribute-answer">{{'UI' | translate}}</span></a>
              @if (busName) {
                <span class="pipe-spacing">|</span>
                <a href="javascript:void(0)" data-automation-id="lm-componentinfo-view-business-logic-link" (click)="runViewBusinessLogic(compInfo, busName, name);"><span class="attribute-answer">{{'BusinessClass' | translate}}</span></a>
              }
            </span>
          </p>
        }
      </div>
      @if (compInfo.configInfo.personalizeTabs) {
        <p data-automation-id="lm-componentinfo-personalize-tabs"><span class="attribute-title label-colon">{{'PersonalizeTabs' | translate}}</span> {{compInfo.configInfo.personalizeTabs}}</p>
      }
      @if (compInfo.configInfo.folder || compInfo.configInfo.isReport) {
        <p class="config-tag-line" data-automation-id="lm-componentinfo-create-report-tag">
          <span class="attribute-title"><span class="report-tag">{{'CreateReportNameSuffix' | translate}}</span></span>
        </p>
      }
    </div>
  }
</ng-template>
</div>